import { useGetFinanceSummary, useGetTransactions } from '@/features/finances/finances.queries';

/**
 * Controller hook for the Finances dashboard page.
 * Combines the KPI summary and the recent transactions feed.
 */
export const useFinancesPage = () => {
  const summaryQuery = useGetFinanceSummary();
  const transactionsQuery = useGetTransactions();

  const transactions = transactionsQuery.data?.items ?? [];

  const isLoading = summaryQuery.isLoading || transactionsQuery.isLoading;
  const isError = summaryQuery.isError || transactionsQuery.isError;

  return {
    summary: summaryQuery.data,
    transactions,
    isLoading,
    isError,
  };
};
